<template>
    <div class="tool-panel-header">
        <div class="header-left">
            <slot name="left" />
            <span class="header-title">{{ title }}</span>
        </div>
        <div class="header-actions">
            <slot name="right" />
            <font-awesome-icon
                v-if="showFullscreen"
                :icon="fullscreen ? 'compress' : 'expand'"
                class="header-icon"
                tabindex="0"
                role="button"
                @click="$emit('toggleFullscreen')"
                @keydown.enter="$emit('toggleFullscreen')"
            />
            <font-awesome-icon
                icon="arrow-down"
                class="header-icon fa-rotate-270"
                tabindex="0"
                role="button"
                @click="$emit('close')"
                @keydown.enter="$emit('close')"
            />
        </div>
    </div>
</template>

<script>
/**
 * Standard header bar for ToolPanel. Shows title, optional fullscreen toggle, and close button.
 * Slots: #left (before title), #right (before fullscreen/close icons).
 * Props: title, fullscreen (current state), showFullscreen.
 * Emits: toggleFullscreen, close.
 */
export default {
    props: {
        title: { type: String, default: '' },
        fullscreen: { type: Boolean, default: false },
        showFullscreen: { type: Boolean, default: true }
    },
    emits: ['toggleFullscreen', 'close']
}
</script>

<style scoped>
.tool-panel-header {
    background: #343A40;
    color: #fff;
    padding: 0 1em;
    height: var(--tool-header-height);
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    flex-shrink: 0;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 0.6em;
}

.header-title {
    font-weight: 600;
    font-size: 1.05em;
    color: #fff;
}

.header-actions {
    display: flex;
    gap: 0.8em;
}

.header-icon {
    cursor: pointer;
    font-size: 1.1em;
    color: #fff;
    transition: opacity 0.2s;
}

.header-icon:focus {
    outline: none;
}

.header-icon:hover {
    color: #A4D300;
}
</style>

<style>
.tool-panel-header .action-icon {
    cursor: pointer;
    font-size: 1.1em;
    color: #fff;
    transition: opacity 0.2s;
}
.tool-panel-header .action-icon:focus { outline: none; }
.tool-panel-header .action-icon:hover { color: #A4D300; }
</style>
